export const SOFTLINE_API_LAGER_SCAN_PALLET =
  '/v1/lagerplatzinhalt/scan-palette/{{code}}';

export const SOFTLINE_API_LAGER_AVAILABLE_STORAGE_LOCATIONS = '/v1/lagerplatzverfuegbar';
export const SOFTLINE_API_LAGER_FINALIZE = '/v1/umlagerung';
